import React from 'react';

import ScheduledClassesRow from '../ScheduledClassesRow';
import styles from './ScheduledClassesTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

export default function ScheduledClassesTable({
  sbatGroups,
  ...scheduleRowProps
}) {
  return (
    <Table className={styles.table}>
      <TableHead className={styles.header}>
        <TableRow>
          <TableCell className={styles.dateTime}>Date & Time</TableCell>
          <TableCell className={styles.topic}>Topic</TableCell>
          <TableCell className={styles.batch}>Batch/es</TableCell>
          <TableCell className={styles.module}>Module Name</TableCell>
          <TableCell className={styles.junctionNumber}>Junction</TableCell>
          <TableCell className={styles.instructor}>
            Primary, Secondary Instructor
          </TableCell>
          <TableCell className={styles.action}>Edit</TableCell>
          <TableCell className={styles.action}>Delete</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {sbatGroups.map((sbatGroup) => (
          <ScheduledClassesRow
            sbatGroup={sbatGroup}
            {...scheduleRowProps}
            key={sbatGroup.id}
          />
        ))}
      </TableBody>
    </Table>
  );
}
